import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext.js";
import ClientContext from "./ClientContext.js";
import StatusContext from './StatusContext.js';
import axios from "axios"
import { config } from '../config.js';
import { sortChats } from './StatusContext.js';

const JobInterviewContext = createContext();

export default JobInterviewContext;

  
export const JobInterviewProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const[chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [status, setStatus] = useState();
    const [topics, setTopics] = useState([]);
    const [subtopics, setSubtopics] = useState([]);
    const [showSubtopics, setShowSubtopics] = useState(false) 
    const [uberTopics, setUberTopics] = useState([[], []]);
    const [showProgressDialog, setShowProgressDialog] = useState(false)
    const [showquestion, setShowQuestion] = useState(true)
    const [expanded, setExpanded] = useState(false);


    const {
        currentUser, 
        checkCurrentUser,
        checkServerCode, 
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        setIsLoading,
        changeLanguage,
        getChats,
        //handleFocus,
        getAIProvider, 
        getAIModel,
        getAIName,

        setWaitOnResponse,
        
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

    const selectQuestion = (id) => {
        console.log("selectQuestion:", id)
    }

    const handleonClickNavBar = async () => {
 
        setStatusNavbar("");
      
          setIsLoading(true);
      
          let chats = await getChats('jobinterview')
            console.log("Chats1:", chats)
       
          if (chats.status !== 200 && chats.status !== 409)
            {
                setStatusNavbar("Unable to retrieve data.")
                setIsLoading(false);
                return;
            }

          console.log("Chats:", chats)
      
          setIsLoading(false);
    
        setExpanded(!expanded)
      }


    const onOpenSave = () => {
        console.log('onOpenSave')
        handleonClickNavBar() 
    }

    const onSendQuestion = async (groupid, questionid) => {
        console.log("onSendQuestion:", groupid, questionid)
        let request = uberTopics[groupid][questionid].subtopic
        console.log('Question:', request)

        setStatus("");
        setIsLoading(true)
        setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
        setShowProgressDialog(true)

         let req = {
            user: currentUser,
            request: request,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        try {
                
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })
    
            let server_response = JSON.parse(res.data);
           
    
            let a = [...uberTopics]
            a[groupid][questionid].response = server_response.data
             a[groupid][questionid].selected = true
            console.log("Question response:",  a[groupid][questionid].response)
            setUberTopics(a)
            updateCredits(server_response.tokens)
            //handleFocus()

            }  catch (err) {
                console.log("Error:", err)
                setStatus(`Error: ${checkServerCode(err.code)}`)
        }

        setIsLoading(false)
        setShowProgressDialog(false)
        
    }

    const onDisplayQuestion = (groupid, questionid) => {
        setShowQuestion(!showquestion)
        uberTopics[groupid][questionid].selected = !uberTopics[groupid][questionid].selected
    }
   
    const onSubmitChat = async () => {

        let totalTokens = 0;

        setStatus("");
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (chatPrompt.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }
           
        setIsLoading(true)
        
        setWaitOnResponse(changeLanguage('jobinterview', 'waitontopics'))
        setShowProgressDialog(true)

        //generate topics
        let rqst= "Generate up to 10 topics from the following context: " + 
            chatPrompt + "." +
            "End each topic with @@@. Provide topics only."

        let req = {
            user: currentUser,
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
       
        let topicsArray = []
            
        try {
                
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })
    
            let server_response = JSON.parse(res.data);
    
            let tokens = server_response.data.split("@@@"); // Split
               
            for (let i = 0; i < tokens.length; ++i)
                {
                    let newStr = tokens[i].replace(/\n/g, "").trim();
                    
                    if (newStr.length > 0)
                    {
                        let b = {
                            id:i,
                            selected: false,
                            subtopic: newStr,
                            }
                        topicsArray.push(b)
                    }
                }
               
            totalTokens += server_response.tokens
            //handleFocus()
            }  catch (err) {
                console.log("Error:", err)
                setStatus(`Error: ${checkServerCode(err.code)}`)
                setIsLoading(false)
                return
            }

               
        let uberTopicsArray = Array(topicsArray.length).fill().map(() => []);
        
        for (let i = 0; i < topicsArray.length; ++i)
        {
            //generate job interview questions
            if (topicsArray[i].subtopic.length === 0)
                continue
            rqst= "Generate up to 5 different job interview questions from the follwing context: " + 
                       chatPrompt + "." +
                       "Focus on this topic:" + 
                       topicsArray[i].subtopic + '.' +
                      "End each question with @@@. Provide questions only."
                     
    
            setWaitOnResponse(`${changeLanguage('jobinterview', 'preparing')} (${i+1} ${changeLanguage('jobinterview', 'of')} ${topicsArray.length}): ${topicsArray[i].subtopic}...`);

            req = {
                user: currentUser,
                request: rqst,
                temperature: 1,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }
       
            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                        withCredentials:true
                })
        
                let server_response = JSON.parse(res.data);
                //console.log("Response:", server_response)
                let tokens = server_response.data.split("@@@"); // Split
                let a = []
                for (let j = 0; j < tokens.length; ++j)
                {
                    let newStr = tokens[j].replace(/\n/g, "").trim();
                        
                    if (newStr.length > 0)
                    {
                        let b = {
                            id:j,
                            selected: false,
                            subtopic: newStr,
                            response:''
                        }
                        a.push(b)
                    }
                }
                    
                uberTopicsArray[i] = a
                    
                totalTokens += server_response.tokens
                  
                } catch (err) {
                    console.log("Error:", err)
                    setStatus(`Error: ${checkServerCode(err.code)}`)
                    setIsLoading(false)
                    setShowProgressDialog(false)
                    return
                    
                }
        }

        updateCredits(totalTokens)

        setTopics([...topicsArray])
        setUberTopics(uberTopicsArray)
        setShowSubtopics(true)
        
        setIsLoading(false)
        setShowProgressDialog(false)
            
    }

     
    const onClearChat = () => {
        setChatName('')
        setStatus('')
        //setChatPrompt('')

        setTopics([])
        setSubtopics([])
        setUberTopics([[],[]])
    }   

    const deleteChat = async (deletionChat) => {

        console.log("Delete story:", deletionChat)

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newchatNames = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/jobinterview/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        //console.log("Adjusted Chats:", adjustedChats)
              
        var templates = JSON.stringify( adjustedChats)
       
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/jobinterview/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return;
        }

        setChatNames(adjustedChats);
        
       
        setIsLoading(false)    
    }

    const displayChat = (displayedChat) => {
        
        onClearChat();

        setTimeout(() => {

        setUberTopics(displayedChat.promptsandresponses)
        setChatName(displayedChat.chatname)
        },0)
    }

    const onSave = async () => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        let exists = false;
    
        let newChats = [];
        let newChat=[];
        let newchatNames = [];


        setIsLoading(true);

        let chatstatus = await getChats('jobinterview');

        console.log('Chatstatus:', chatstatus)

        if (chatstatus.status !== 200)
        {
            setStatusNavbar("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }

                    chat.promptsandresponses = uberTopics;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0;

            newchatNames === 0 ? i = 1 : i = newchatNames.length;

            newChat = {
                id: i,
                chatname: chatName,
                promptsandresponses: uberTopics,
            };

            newChats.push(newChat);
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
        }
            
        let templates = JSON.stringify( newChats)

        console.log("Templates size:", templates.length)
       
        
        try{
           await axios.post(config.url.API_URL + "/deda_ai_api/jobinterview/save", {currentUser, templates},{
                withCredentials:true
            })
        }
        catch (err) {
            setIsLoading(false);
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            return;
        }
       
        setChatNames(newChats)
        setIsLoading(false);
        
    }

    
    return <JobInterviewContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse, 
    
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,
        onClearChat,
        onSave,
        deleteChat,
        displayChat,

        status,
        setStatus,
       
        topics,
        subtopics,
        showSubtopics,
        uberTopics,

        selectQuestion,
        showProgressDialog,

        showquestion,

        onSendQuestion,
        onDisplayQuestion,
        onOpenSave,
        expanded, 
        setExpanded,
       
    }}>
        {props.children}
    </JobInterviewContext.Provider>
})

